import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnDate,
  columnNameLink,
  columnStatus,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';

const DataModelReportsTableColumns = ({ columns }) => (
  <>
    <Table.Row>
      {hasColumn(columns, columnNameLink) && (<UnsortedColumn columnId={columnNameLink} />)}
      {hasColumn(columns, columnDate) && (<UnsortedColumn columnId={columnDate} />)}
      {hasColumn(columns, columnStatus) && (<UnsortedColumn columnId={columnStatus} />)}
      {hasColumn(columns, columnTools) && (<UnsortedColumn />)}
    </Table.Row>
  </>
);

export default DataModelReportsTableColumns;
